import { render, staticRenderFns } from "./AllocationUnitDetailsBudget.vue?vue&type=template&id=2e1cd77a&scoped=true&"
import script from "./AllocationUnitDetailsBudget.vue?vue&type=script&lang=js&"
export * from "./AllocationUnitDetailsBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1cd77a",
  null
  
)

export default component.exports